'use client';
import { useCallback } from 'react';

function setRef(ref, instance) {
  if (ref instanceof Function) {
    ref(instance);
  } else if (ref != null) {
    ref.current = instance;
  }
}
function combinedRef(refs) {
  return (instance) => refs.forEach((ref) => setRef(ref, instance));
}
function useMultipleRefs(...refs) {
  return useCallback(combinedRef(refs), refs);
}

export { combinedRef, useMultipleRefs };
